// Вкладки табов магазина (position: fixed) подтягиваются вверх при скролле —
// от высоты UserHeader (изначально дырка над табами им и заполнена) до 10px
// (вровень с плавающей кнопкой «Назад»), чтобы дырка не оставалась пустой
export const SHOP_TABS_TOP_MAX = 70;
export const SHOP_TABS_TOP_MIN = 10;

/**
 * Значение top для панели табов при текущей прокрутке страницы.
 *
 * К смещению ВСЕГДА прибавляется --safe-area-top: сам UserHeader сдвинут вниз
 * на высоту системного статус-бара (padding-top у .menu-screens-container), а
 * fixed-табы отсчитываются от вьюпорта и этим паддингом не сдвигаются — без
 * прибавки в полноэкранном режиме на мобильных они наезжали на хедер ровно на
 * эту величину. Прибавка остается в CSS-выражении, а не считается числом в JS:
 * env() резолвит браузер, и значение само обновится при повороте экрана или
 * выходе из полноэкранного режима.
 *
 * Инлайновый стиль перебивает правило в ShopPage.css, поэтому отступ обязан
 * быть именно здесь — правки одного лишь CSS ни на что не влияют.
 *
 * @param {number} scrollY - текущая прокрутка документа
 * @returns {string} значение для style.top
 */
export const getShopTabsTopStyle = (scrollY) => {
  const top = Math.max(SHOP_TABS_TOP_MIN, SHOP_TABS_TOP_MAX - scrollY);

  return `calc(${top}px + var(--safe-area-top))`;
};
